import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'

export const GET_QUESTION_TYPES_LIST = 'GET_QUESTION_TYPES_LIST'
export const GET_QUESTION_TYPES_LIST_SUCCESS = 'GET_QUESTION_TYPES_LIST_SUCCESS'

export const Actions = {
  questionTypesList: () => createAction(GET_QUESTION_TYPES_LIST),
  questionTypesListSuccess: (questionTypes: any) =>
    createAction(GET_QUESTION_TYPES_LIST_SUCCESS, questionTypes),
}

export type Actions = ActionsUnion<typeof Actions>
